// Browser-native media playback remains available when CORS blocks script
// access to a private video. Unlike WebAudio, HTMLVideoElement may stream an
// opaque cross-origin source without reading the file in JavaScript.
export function reachedNativePassageEnd(time,end,seeking=false){
 return !seeking&&Number.isFinite(time)&&Number.isFinite(end)&&time>=end-.02;
}
export function waitForVideoReady(player,time,{timeoutMs=12000}={}){
 if(!player||!Number.isFinite(time)||time<0)return Promise.reject(new Error('Invalid video playback position.'));
 return new Promise((resolve,reject)=>{
  let timer=null;
  const done=error=>{
   player.removeEventListener('loadedmetadata',onMetadata);
   player.removeEventListener('seeked',onSeeked);
   player.removeEventListener('error',onError);
   clearTimeout(timer);
   if(error)reject(error);else resolve();
  };
  const onError=()=>done(new Error('The source video could not be loaded by the browser.'));
  const onSeeked=()=>{
   if(!player.seeking&&Math.abs(player.currentTime-time)<.12)done();
  };
  const onMetadata=()=>{
   try{
    if(player.error)return onError();
    if(Math.abs(player.currentTime-time)<.025&&!player.seeking)return done();
    player.currentTime=time;
    if(!player.seeking&&Math.abs(player.currentTime-time)<.12)done();
   }catch(error){done(error);}
  };
  player.addEventListener('loadedmetadata',onMetadata);
  player.addEventListener('seeked',onSeeked);
  player.addEventListener('error',onError);
  timer=setTimeout(()=>done(new Error('Video loading took too long.')),timeoutMs);
  if(player.readyState>=1)onMetadata();
 });
}
